module.exports = {
  getCards: '/tapapi/v2/common/cards',
  applicationPins: '/tapapi/v2/usermanagement/application-pins',
  getUserProfile: '/tapapi/v2/usermanagement/getuserprofile',
  updateUserProfile: '/tapapi/v2/usermanagement/updateuserprofile',
  releaseNotes: '/tapapi/v2/common/releasenotes/{module}/{version}',
  chatConfigUrl: '/tapapi/v2/common/tapchat/tap/version',
  getChatAccessTokenUrl: '/tapapi/tap_jwt_provider/v1/public/accessToken/generate',
  tapConfigurationsUrl: '/tapapi/v2/common/tapconfigurations',
  getUnreadNotificationsCount: '/tapapi/helpdesk/v1/public/notifications',
  profileUpload: '/tapapi/v2/usermanagement/upload/profile-picture',
  deleteProfileImage: '/tapapi/v2/usermanagement/delete/profile-picture',
  logout: '/tapapi/v2/core/logout',
  tokenInvalidate: '/taprole/public/profile/token/invalidate',
  // Support Portal Urls
  getSupportBrands: '/tapapi/helpdesk/v1/public/ticket_create/brands',
  searchSupportUsers: '/tapapi/userservice/v1/public/users/search?query=',
  groupsFilter: '/tapapi/userservice/v1/public/groups/filter?users=true',
  createTicket: '/tapapi/helpdesk/v1/public/portal_ticket',
  uploadAttachments: '/tapapi/helpdesk/v1/public/attachment',
  getTicketFields: '/tapapi/helpdesk/v1/public/forms/{formId}?associated_fields=true',
  getTicketCreationFields: '/tapapi/helpdesk/v1/public/ticketCreationFields',
  // Superset dashboard urls
  getSupersetDashboardData: '/tapapi/analytics/superset-embedding/public/dashboard/{id}',
  getPusherCred: '/tapapi/v2/common/pusherinfo/default'
};